import {BaseRequest, Severity} from "@dabnet-kamu/libs/gen";


export class BaseRequest_1<E>
{

  public constructor(init?: Partial<BaseRequest_1<E>>) { (Object as any).assign(this, init); }
}

export class ValidationFailure
{
  public propertyName: string;
  public errorMessage: string;
  public attemptedValue: Object;
  public customState: Object;
  public severity: Severity;
  public errorCode: string;
  public formattedMessagePlaceholderValues: { [index: string]: Object; };

  public constructor(init?: Partial<ValidationFailure>) { (Object as any).assign(this, init); }
}

export class ValidationResult
{
  public isValid: boolean;
  public errors: ValidationFailure[];
  public ruleSetsExecuted: string[];

  public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}


export class BaseResponse
{
  public result: boolean;
  public errorCode: string;
  public errorMessage: string;
  public errors: string[];
  public warnings: string[];
  public errorDetails: string[];
  public totalPages: number;
  public totalCount: number;
  public pageSize: number;
  public vError: ValidationResult;

  public constructor(init?: Partial<BaseResponse>) { (Object as any).assign(this, init); }
}

export interface IReturn<T>
{
  createResponse(): T;
}


export class GysVergiOrtak_SpIhbar_Response extends BaseResponse
{
  public poIslemYapildiEh: string;
  public islemKod: string;


  public constructor(init?: Partial<GysVergiOrtak_SpIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class TemGUI_GenelDetaySil_Response extends BaseResponse
{
  public kod: number;
  public tabload: number;


  public constructor(init?: Partial<TemGUI_GenelDetaySil_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysOrtak_SpMatbuTahakkukHazirlama_Response extends BaseResponse
{
  public poKisiKod: number;
  public poModulKod: number;
  public poAdet: number;
  public poCarpan: number;
  public poGelirKod: number;
  public poTarife: number;
  public poToplamTutar: number;


  public constructor(init?: Partial<TemGUI_GenelDetaySil_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysOrtak_SpMatbuTahakkukOlustur_Response extends BaseResponse
{
  public poTahakkukAnaKod: number;


  public constructor(init?: Partial<TemGUI_GenelDetaySil_Response>) { super(init); (Object as any).assign(this, init); }
}


export class TemGUI_GenelSeciliDetaySil_Response extends BaseResponse
{
  public kodlar: [];
  public tabload: string;


  public constructor(init?: Partial<TemGUI_GenelDetaySil_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_DosyaMuhasebeKontrol_Response extends BaseResponse
{
  public muhasebelesti_Eh: string;
  public tifGiris_Eh: string;


  public constructor(init?: Partial<StsGUI_DosyaMuhasebeKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_MuayeneMuhasebeKontrol_Response extends BaseResponse
{
  public muhasebelesti_Eh: string;
  public tifGiris_Eh: string;


  public constructor(init?: Partial<StsGUI_MuayeneMuhasebeKontrol_Response>) { super(init); (Object as any).assign(this, init); }
}

export class StsGUI_DefaultGetir_Response extends BaseResponse
{
  public HesapKod: string;
  public FonksiyonelKod: string;
  public FinansmanKod: string;
  public EkoGiderKod: string;


  public constructor(init?: Partial<StsGUI_DefaultGetir_Response>) { super(init); (Object as any).assign(this, init); }
}


export class GysMahsup_SpBorcAlacakSorgula_Response extends BaseResponse
{
  public PoIslemKod: string;


  public constructor(init?: Partial<TemGUI_GenelDetaySil_Response>) { super(init); (Object as any).assign(this, init); }
}


export class GysMahsup_SpMahsupDengele_Response extends BaseResponse
{
  public SecBorc: number;
  public SecAlacak: number;


  public constructor(init?: Partial<GysMahsup_SpMahsupDengele_Response>) { super(init); (Object as any).assign(this, init); }
}





export class TemGUI_GenelDetaySil_Request extends BaseRequest_1<TemGUI_GenelDetaySil_Response> implements IReturn<TemGUI_GenelDetaySil_Response>
{
  public kod: number;
  public tabloAd: string;

  public constructor(init?: Partial<TemGUI_GenelDetaySil_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'TemGUI_GenelDetaySil_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new TemGUI_GenelDetaySil_Response(); }
}


export class MisGUI_DetaySil_Request implements IReturn<BaseResponse>
{
  public istekKod: number;
  public silmeTipi: number;

  public constructor(init?: Partial<MisGUI_DetaySil_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'MisGUI_DetaySil_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

export class GysOrtak_SpMatbuTahakkukHazirlama_Request extends BaseRequest_1<GysOrtak_SpMatbuTahakkukHazirlama_Response> implements IReturn<GysOrtak_SpMatbuTahakkukHazirlama_Response>
{
  public piKisiKod: number;
  public piModulKod: number;

  public constructor(init?: Partial<GysOrtak_SpMatbuTahakkukHazirlama_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysOrtak_SpMatbuTahakkukHazirlama_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysOrtak_SpMatbuTahakkukHazirlama_Response(); }
}

export class GysOrtak_SpMatbuTahakkukOlustur_Request extends BaseRequest_1<GysOrtak_SpMatbuTahakkukOlustur_Response> implements IReturn<GysOrtak_SpMatbuTahakkukOlustur_Response>
{
  public piKisiKod: number;
  public piModulKod: number;
  public piAdet: number;
  public piCarpan: number;
  public piGelirKod: number;
  public piTarife: number;
  public piToplamTutar: number;

  public constructor(init?: Partial<GysOrtak_SpMatbuTahakkukOlustur_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysOrtak_SpMatbuTahakkukOlustur_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysOrtak_SpMatbuTahakkukOlustur_Response(); }
}

export class StsGUI_DosyaMuhasebeKontrol_Request extends BaseRequest_1<StsGUI_DosyaMuhasebeKontrol_Response> implements IReturn<StsGUI_DosyaMuhasebeKontrol_Response>
{
  public ihaleKod: number;

  public constructor(init?: Partial<StsGUI_DosyaMuhasebeKontrol_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'StsGUI_DosyaMuhasebeKontrol_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new StsGUI_DosyaMuhasebeKontrol_Response(); }
}



export class StsGUI_MuayeneMuhasebeKontrol_Request extends BaseRequest_1<StsGUI_MuayeneMuhasebeKontrol_Response> implements IReturn<StsGUI_MuayeneMuhasebeKontrol_Response>
{
  public muayeneKod: number;

  public constructor(init?: Partial<StsGUI_MuayeneMuhasebeKontrol_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'StsGUI_MuayeneMuhasebeKontrol_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new StsGUI_MuayeneMuhasebeKontrol_Response(); }
}




export class TemGUI_GenelSeciliDetaySil_Request extends BaseRequest_1<TemGUI_GenelSeciliDetaySil_Response> implements IReturn<TemGUI_GenelSeciliDetaySil_Response>
{
  public kodlar: [];
  public tabloAd: string;

  public constructor(init?: Partial<TemGUI_GenelSeciliDetaySil_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'TemGUI_GenelSeciliDetaySil_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new TemGUI_GenelSeciliDetaySil_Response(); }
}


export class GysMahsup_SpBorcAlacakSorgula_Request extends BaseRequest_1<GysMahsup_SpBorcAlacakSorgula_Response> implements IReturn<GysMahsup_SpBorcAlacakSorgula_Response>
{
  public PiKisiKod: number;
  public PiTahsilatKod: number;
  public PiTahsilTarih: Date;
  public PiIlkYil: number;
  public PiIlkDonem: number;
  public PiSonYil: number;
  public PiSonDonem: number;
  public PiGecikmeEh: string;

  public constructor(init?: Partial<GysMahsup_SpBorcAlacakSorgula_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysMahsup_SpBorcAlacakSorgula_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysMahsup_SpBorcAlacakSorgula_Response(); }
}


// @Route("/Gen/TeklifGuncelle", "Post")
export class ExcelGUI_TeklifGuncelle_Request implements IReturn<BaseResponse>
{
  public fileName: string;
  public mimeType: string;
  public fileData: string;

  public constructor(init?: Partial<ExcelGUI_TeklifGuncelle_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'ExcelGUI_TeklifGuncelle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}


export class ExcelGUI_IhaleGuncel_Request implements IReturn<BaseResponse>
{
  public teklifKod: number;
  public fileName: string;
  public mimeType: string;
  public fileData: string;

  public constructor(init?: Partial<ExcelGUI_IhaleGuncel_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'ExcelGUI_IhaleGuncel_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}







export class StsGUI_MuayeneGuncelle_Request implements IReturn<BaseResponse>
{
  public muayeneKod: number;
  public adets: any[];
  public islemAdets: any[];
  public birimKatsayis: any[];
  public kods: any[];
  public toplamTutars: any[];

  public constructor(init?: Partial<StsGUI_MuayeneGuncelle_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'StsGUI_MuayeneGuncelle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

export class StsGUI_TeklifKabul_Request implements IReturn<BaseResponse>
{
  public teklifKod: number;
  public constructor(init?: Partial<StsGUI_TeklifKabul_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'StsGUI_TeklifKabul_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}



export class GysVergiOrtak_SpIhbar_Request extends BaseRequest_1<GysVergiOrtak_SpIhbar_Response> implements IReturn<GysVergiOrtak_SpIhbar_Response>
{
  public piModulKod: number;
  public piIslemTuru: string;
  public piKisiKod: number;
  public piBeyanTuru: number;
  public piBeyanTarih: Date;
  public piTahakTarih: Date;
  public piIslemKod: string;
  public piIlkSiraNo: number;
  public piSonSiraNo: number;
  public piIlkYil: number;
  public piSonYil: number;
  public piTarhiyatTuru: number;

  public constructor(init?: Partial<GysVergiOrtak_SpIhbar_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysVergiOrtak_SpIhbar_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysVergiOrtak_SpIhbar_Response(); }
}

export class GysOrtak_SpIhbar_Response extends BaseResponse
{
  public poIslemYapildiEh: string;
  public poIslemKod: string;
  public poRaporAdi: string;

  public constructor(init?: Partial<GysOrtak_SpIhbar_Response>) { super(init); (Object as any).assign(this, init); }
}

export class GysOrtak_SpIhbar_Request extends BaseRequest_1<GysOrtak_SpIhbar_Response> implements IReturn<GysOrtak_SpIhbar_Response>
{
  public piModulKod: number;
  public piIslemTuru: string;
  public piKisiKod: number;
  public piBeyanListesi: number[];
  public piBeyanTuru: number;
  public piBeyanTarih?: string;
  public piTahakTarih?: string;
  public piIslemKod: string;
  public piIlkYil: number;
  public piSonYil: number;
  public piTarhiyatTuru: number;
  public piAciklama: string;

  public constructor(init?: Partial<GysOrtak_SpIhbar_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysOrtak_SpIhbar_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysOrtak_SpIhbar_Response(); }
}


export class StsGUI_DefaultGetir_Request extends BaseRequest_1<StsGUI_DefaultGetir_Response> implements IReturn<StsGUI_DefaultGetir_Response>
{
  public piIhaleDetayKod: number;
  public tasinirKod: string;

  public constructor(init?: Partial<StsGUI_DefaultGetir_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'StsGUI_DefaultGetir_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new StsGUI_DefaultGetir_Response(); }
}


export class GysGUI_BorcKontrol_Request implements IReturn<BaseResponse>
{
  public kaynak: string;
  public kisiKod: number;
  public beyanKodList: number[];

  public constructor(init?: Partial<GysGUI_BorcKontrol_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'GysGUI_BorcKontrol_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

export class GysTakip_SpHacizIsle_Request implements IReturn<BaseResponse>
{
  public piIlkKisiKod: number;
  public piSonKisiKod: number;
  public piIlkDuzenlemeTarih: string;
  public piSonDuzenlemeTarih: string;
  public piHacizTarih: string;
  public piOnayTarih: string;
  public piIcraPersonelKod: number;
  public piMudurPersonelKod: number;
  public piOnayPersonelKod: number;
  public piIcraRolAd: string;
  public piMudurRolAd: string;
  public piOnayRolAd: string;

  public constructor(init?: Partial<GysTakip_SpHacizIsle_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'GysTakip_SpHacizIsle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

export class GysGUI_Beyan_SuretTamam_Request implements IReturn<BaseResponse>
{
  public KisiKod: number;
  public SiraNo: number;
  public EmlakBeyanTuru: number;
  public HarcEh: string;

  public constructor(init?: Partial<GysGUI_Beyan_SuretTamam_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'GysGUI_Beyan_SuretTamam_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

export class GysGUI_EmlakBeyanTezyidGuncelle_Request implements IReturn<BaseResponse>
{
  public beyanKod: number;
  public yil: number;
  public matrahFarkTutar: number;

  public constructor(init?: Partial<GysGUI_EmlakBeyanTezyidGuncelle_Request>) { (Object as any).assign(this, init); }
  public getTypeName() { return 'GysGUI_EmlakBeyanTezyidGuncelle_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}

// export class GysMahsup_SpMahsupDengele_Request implements IReturn<BaseResponse>
// {
//   public PiIslemKod: string;
//
//   public constructor(init?: Partial<GysMahsup_SpMahsupDengele_Request>) { (Object as any).assign(this, init); }
//   public getTypeName() { return 'GysMahsup_SpMahsupDengele_Request'; }
//   public getMethod() { return 'POST'; }
//   public createResponse() { return new BaseResponse(); }
// }

export class GysMahsup_SpMahsupDengele_Request extends BaseRequest_1<GysMahsup_SpMahsupDengele_Response> implements IReturn<GysMahsup_SpMahsupDengele_Response>
{
  public PiIslemKod: string;
  public PiAlacakKodList: [];
  public PiBorcKodlist: [];

  public constructor(init?: Partial<GysMahsup_SpMahsupDengele_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GysMahsup_SpMahsupDengele_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GysMahsup_SpMahsupDengele_Response(); }
}

export class FormDetayHistoryDto
{
  public kod: number;
  public aciklama: string;
  public cagriAdet: number;
  public sonIstekTarih?: string;

  public constructor(init?: Partial<FormDetayHistoryDto>) { (Object as any).assign(this, init); }
}
export class GetLastXAction_Response extends BaseResponse
{
  public history: FormDetayHistoryDto[];

  public constructor(init?: Partial<GetLastXAction_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetLastXAction", "POST")
export class GetLastXAction_Request extends BaseRequest_1<GetLastXAction_Response> implements IReturn<GetLastXAction_Response>
{
  public formAd: string;

  public constructor(init?: Partial<GetLastXAction_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GetLastXAction_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GetLastXAction_Response(); }
}

// DKM-5606 Kayra: mükerrer kişi birleştirme ön kontrolü (servis: GenKisiBirlesServices / SP_KISI_BIRLES_KONTROL)
export class GenKisiBirles_SpKisiBirlesKontrol_Request extends BaseRequest_1<BaseResponse> implements IReturn<BaseResponse>
{
  public piKaynakKisiKod: number;
  public piHedefKisiKod: number;

  public constructor(init?: Partial<GenKisiBirles_SpKisiBirlesKontrol_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GenKisiBirles_SpKisiBirlesKontrol_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new BaseResponse(); }
}
